import React, { useEffect, useState } from 'react';
import './header.css'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
// @ts-ignore
import { zynity_website, zynity_api } from '../../config/external-routes';
import { useSelector } from 'react-redux'
import MyHomepageIcon from '../../assets/images/my_homepage_icon.svg';




export const Header = () => {

	const yii_url = zynity_website.yii_website_url;
	const user = useSelector((state:any) => state.auth)

	// IA Limits and Knowledge Gaps are gated by the same backend admin_emails
	// allowlist (see EngagementAiUsageSupportService::canAccess), so one access
	// check decides both menu items. The backend remains the real gate either
	// way - this only controls whether the links are shown.
	const [zyniAdminAccess, setZyniAdminAccess] = useState(false);

	useEffect(() => {
		let mounted = true;
		if (!user?.email) {
			setZyniAdminAccess(false);
			return;
		}

		axios.get(zynity_api.engagement_ai_limits_access)
			.then((response) => {
				if (mounted) setZyniAdminAccess(!!response.data?.access?.enabled);
			})
			.catch(() => {
				if (mounted) setZyniAdminAccess(false);
			});

		return () => { mounted = false; };
	}, [user?.email]);

	return (
		<nav className="nav navbar-light bg-white d-flex align-items-center justify-content-center">
			<li className="nav-item hoverable">
				<img src={require('../../assets/images/zynity_logo.png')} width="100"></img>&nbsp;
			</li>
			<li className="nav-item">
				<Link to="/" className="linkComunity">
					<div className="comunityBtn">
						My&nbsp;Homepage
						&nbsp;<img src={MyHomepageIcon} width={22} alt="Home"></img>
					</div>
				</Link>
			</li>
			{
				user.is_coach &&
				<li className="nav-item ms-2">
					<Link to="/coach">
						<img src={require('../../assets/images/coach_notes_icon.png')} width="40"></img>
					</Link>
				</li>
			}
			<li className="nav-item ms-2">
				<button id="dropdownUserMenu" type="button" className="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					{user.know_as === undefined ? 'Menu' : `${user.know_as}'s Menu`}
				</button>

				<ul className="dropdown-menu" aria-labelledby="dropdownUserMenu">
					<li><Link to="/" className="dropdown-item">My Homepage</Link></li>
					<li><Link to="/user/profile" className="dropdown-item">My Profile</Link></li>
					{
						user.is_coach &&
						<li><Link to="/coach" className="dropdown-item">Coach Dashboard</Link></li>
					}
					{
						user.visibility_profile == 'Zadmin' &&
						<li><Link to="/admin/z-admin" className="dropdown-item">Z Admin</Link></li>
					}
					{
						zyniAdminAccess &&
						<li><Link to="/ia-limits" className="dropdown-item">AI Limits</Link></li>
					}
					{
						zyniAdminAccess &&
						<li><Link to="/knowledge-gaps" className="dropdown-item">Knowledge Gaps</Link></li>
					}
						<li><Link to="/how-lead" className="dropdown-item">How You Lead</Link></li>
						<li><Link to="/notifier-app" className="dropdown-item">Notifier App</Link></li>
					<li><Link to="/logout" className="dropdown-item">Logout</Link></li>
				</ul>
			</li>
			<li className="nav-item ms-2">
				<button id="dropdownBurgerMenu" type="button" className="btn dropdown-toggle remove-arrow" data-bs-toggle="dropdown" aria-expanded="false">
				<FontAwesomeIcon icon={faBars} />
				</button>

				<ul className="dropdown-menu" aria-labelledby="dropdownBurgerMenu">
					<li><a className="dropdown-item" target="_blank" href={zynity_website.public}>Public Site</a></li>
					<li><a className="dropdown-item" href="/help-request">Help Request</a></li>
					<li><Link to="/logout" className="dropdown-item">Logout</Link></li>
				</ul>
			</li>

		</nav>
	)
}
